"use client";

import FAQPage from "@/app/versioning/page/staticPages/Faq";

export default FAQPage;
